import { render, staticRenderFns } from "./PollsTab.vue?vue&type=template&id=a705afb2&"
import script from "./PollsTab.vue?vue&type=script&lang=js&"
export * from "./PollsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports